export default __webpack_public_path__ + "static/media/MillsMixBrdv2.1ed99155.png";